import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { tomos } from '../data/content';
export function Tomos() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="sistema" className="w-full bg-white" aria-labelledby="tomos-titulo" data-id="element-187" data-mp="1h4dt67ljwchf">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:px-6 sm:py-16" data-id="element-188" data-mp="1cat4x79rewvf">
        <div className="mx-auto max-w-3xl text-center" data-id="element-189" data-mp="1r0h7scxla3l9">
          <h2 id="tomos-titulo" className="font-display text-[1.6rem] leading-[1.05] text-ink-strong sm:text-4xl" data-id="element-190" data-mp="1r33ds84u0b1d">
            El sistema completo para ordenar cada parte de tu Airbnb
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-ink sm:text-base" data-id="element-191" data-mp="1vztumxognanu">
            Cada tomo profesionaliza una zona crítica de tu gestión:
            configuración, comunicación, check-in, rentabilidad, plantillas y
            control de calidad.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3" data-id="element-192" data-mp="34qzwrxic3ury">
          {tomos.map((tomo, index) => {
          const isOpen = openIndex === index;
          return <li key={tomo.numero} className="rounded-xl border border-surface-line bg-white shadow-card lg:flex lg:flex-col lg:p-5" data-id="element-193" data-mp="3eow5kinsudmw" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-3.5 text-left lg:pointer-events-none lg:block lg:p-0" data-id="element-194" data-mp="3jhpbvayx1u13">
                  <span className="shrink-0 rounded-md bg-brand px-2 py-1 text-[10px] font-extrabold uppercase tracking-wide text-white lg:inline-block" data-id="element-195" data-mp="186nvy0i3u44">
                    {tomo.numero}
                  </span>
                  <span className="font-display min-w-0 flex-1 text-base leading-tight text-ink-strong lg:mt-3 lg:block lg:text-xl" data-id="element-196" data-mp="280fpafkhqlvk">
                    {tomo.titulo}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-ink-muted transition-transform duration-200 ease-out lg:hidden ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-197" data-mp="1vy646d0tqbie" />
                </button>
                <p className={`px-4 pb-4 text-[13px] leading-relaxed text-ink lg:mt-2 lg:block lg:p-0 lg:text-sm ${isOpen ? 'block' : 'hidden'}`} data-id="element-198" data-mp="2iydri3urlt96">
                  {tomo.descripcion}
                </p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-8 max-w-sm" data-id="element-199" data-mp="2nqdnjl7ps20h">
          <CTAButton label="Quiero mi Airbnb ordenado" size="lg" fullWidth data-id="element-200" data-mp="2nroq5hpfb3q0" />
          <p className="mt-2.5 text-center text-[11px] font-semibold text-ink-muted" data-id="element-201" data-mp="32muu7z4yksgp">
            Acceso inmediato · Pago único · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}